import type { PublicNavContext } from "../publicNavigation";
import { getContactNavItem } from "./company";
import type { NavConfig } from "./types";

/**
 * "Om oss" is the fifth header hub. Its link still opens /om-oss; the
 * dropdown holds Careers and Contact (owner 2026-10-23).
 */
export function getAboutNavConfig(ctx: PublicNavContext): NavConfig["about"] {
  const { isSwedish } = ctx;
  const overview = isSwedish ? "/om-oss" : "/en/about";
  return {
    label: isSwedish ? "Om oss" : "About",
    overview,
    submenu: {
      overview: {
        label: isSwedish ? "Om Caire" : "About Caire",
        href: overview,
        description: isSwedish
          ? "Varför vi bygger Caire och vilka vi är"
          : "Why we build Caire and who we are",
      },
      items: [
        getContactNavItem(ctx),
        {
          label: isSwedish ? "Karriär" : "Careers",
          href: isSwedish ? "/karriar" : "/en/careers",
          description: isSwedish
            ? "Lediga roller och hur vi anställer"
            : "Open roles and how we hire",
        },
      ],
    },
  };
}
